import React from 'react';

class ChatPremadeResponsesComponent extends React.Component
{

	render(){
		const chatMessages = this.props.chatMessages;
		if(!chatMessages.match)
		{
			return null;
		}
		let premadeResponses = [];
		if(chatMessages.match && chatMessages.match.match_muted && chatMessages.match.match_muted.responses)
		{
			premadeResponses = chatMessages.match.match_muted.responses.map((response)=>{
				const buttonProperties = {};
				buttonProperties.onClick = chatMessages.send.bind(chatMessages, response.response, response.id);
				buttonProperties.key = response.id;
				if(this.props.isDisabled)
				{
					buttonProperties.disabled = 'disabled';
				}
				return (
					<button {...buttonProperties} className='premade_response btn-sm btn'>
						<span className='response'>{response.response}</span>
					</button>
				);
			});
		}
		return(
			<React.Fragment>
				{!!premadeResponses.length &&
				<div className='premade_responses visible'>
					{premadeResponses}
				</div>
				}
			</React.Fragment>
		)
	}



}

export {ChatPremadeResponsesComponent};